var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-tasklists assessment-add-section" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c("masteradmin-sidebar-menu"),
          _vm._v(" "),
          _c("div", { staticClass: "content-wrapper" }, [
            _c("div", { staticClass: "container-wrapper center" }, [
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "col-6 padding-lr-5 float-left",
                    staticStyle: { "padding-left": "0", "padding-top": "5px" }
                  },
                  [
                    _c("h3", { staticClass: "d-inline heading" }, [
                      _c(
                        "div",
                        {
                          staticClass: "float-left",
                          staticStyle: { "padding-top": "2px" }
                        },
                        [
                          _vm._v(
                            "Edit Assessment: " +
                              _vm._s(
                                _vm.assessment_section_obj.assessment.name
                              ) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "float-left",
                          staticStyle: { "padding-top": "2px" }
                        },
                        [
                          _c("i", {
                            staticClass:
                              "cursor-pointer assessment-edit-icon fa fa-pencil-square-o",
                            attrs: { "aria-hidden": "true" },
                            on: {
                              click: function($event) {
                                ;(_vm.isEditModalVisible = true),
                                  _vm.verrors.clear()
                              }
                            }
                          })
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-2 float-left padding-lr-5" }, [
                  _c(
                    "div",
                    {
                      staticClass: "search-padd",
                      attrs: { id: "mentee-group-wrapper" }
                    },
                    [
                      _c("multiselect", {
                        attrs: {
                          options: _vm.roles_options,
                          "track-by": "name",
                          label: "name",
                          placeholder: "Select Users...",
                          multiple: true,
                          "close-on-select": false,
                          "show-labels": false,
                          name: "roles_show",
                          id: "roles_show"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "selection",
                            fn: function(ref) {
                              var values = ref.values
                              var search = ref.search
                              var isOpen = ref.isOpen
                              return [
                                values.length && !isOpen
                                  ? _c(
                                      "span",
                                      { staticClass: "multiselect__single" },
                                      [
                                        _vm._v(
                                          _vm._s(values.length) + " selected"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.roles_selected,
                          callback: function($$v) {
                            _vm.roles_selected = $$v
                          },
                          expression: "roles_selected"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-2 float-left padding-lr-5" }, [
                  _c(
                    "div",
                    {
                      staticClass: "search-padd",
                      attrs: { id: "mentee-group-wrapper" }
                    },
                    [
                      _c("multiselect", {
                        attrs: {
                          options: _vm.affiliate_options,
                          "track-by": "name",
                          label: "name",
                          placeholder: "Select Affiliates...",
                          multiple: true,
                          "close-on-select": false,
                          "show-labels": false,
                          name: "affiliate_show",
                          id: "affiliate_show"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "selection",
                            fn: function(ref) {
                              var values = ref.values
                              var search = ref.search
                              var isOpen = ref.isOpen
                              return [
                                values.length && !isOpen
                                  ? _c(
                                      "span",
                                      { staticClass: "multiselect__single" },
                                      [
                                        _vm._v(
                                          _vm._s(values.length) + " selected"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.affiliate_selected,
                          callback: function($$v) {
                            _vm.affiliate_selected = $$v
                          },
                          expression: "affiliate_selected"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-2 padding-lr-5 float-right text-align-right",
                    staticStyle: { "padding-right": "0" }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-white col-9 override-padding",
                        staticStyle: {
                          height: "30px",
                          "border-radius": "10px",
                          "font-weight": "bold"
                        },
                        on: {
                          click: function($event) {
                            return _vm.addSectionClick()
                          }
                        }
                      },
                      [_vm._v("Add Section")]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { clear: "both" } }),
              _vm._v(" "),
              _c("div", { staticClass: "heading-seperator" }),
              _vm._v(" "),
              _c("div", { staticClass: "margin-bottom-10" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12 override-padding assessment-intro",
                  staticStyle: { "margin-top": "15px" }
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 override-padding" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-9 float-left override-padding",
                        staticStyle: {
                          "padding-right": "15px",
                          "margin-bottom": "10px",
                          "padding-bottom": "30px",
                          height: "250px"
                        }
                      },
                      [
                        _c("vue-editor", {
                          ref: "textarea",
                          attrs: {
                            editorToolbar: _vm.customToolbar,
                            placeholder: "Enter Intro Text"
                          },
                          on: { "text-change": _vm.introTextChange },
                          model: {
                            value: _vm.assessment_intro,
                            callback: function($$v) {
                              _vm.assessment_intro = $$v
                            },
                            expression: "assessment_intro"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-3 float-left override-padding" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "col-12 override-padding intro-text",
                            on: {
                              click: function($event) {
                                return _vm.inclIntroText("{ User_First_Name }")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                { User_First_Name }\n              "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-12 override-padding intro-text",
                            staticStyle: { "margin-top": "10px" },
                            on: {
                              click: function($event) {
                                return _vm.inclIntroText("{ Answer_Scale }")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                { Answer_Scale }\n              "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-12 override-padding intro-text",
                            staticStyle: { "margin-top": "10px" },
                            on: {
                              click: function($event) {
                                return _vm.inclIntroText("{ Account_Name }")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                { Account_Name }\n              "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-12 override-padding intro-text",
                            staticStyle: { "margin-top": "10px" },
                            on: {
                              click: function($event) {
                                return _vm.inclIntroText("{ Time_to_Complete }")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                { Time_to_Complete }\n              "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-12 override-padding intro-text",
                            staticStyle: { "margin-top": "10px" },
                            on: {
                              click: function($event) {
                                return _vm.inclIntroText("{ #_of_Statements }")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                { #_of_Statements }\n              "
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.assessment_section_obj.sections.length == 0 &&
              _vm.loading == false
                ? _c(
                    "div",
                    { staticClass: "col-12 float-left no-section-display" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-12 float-left text-heading" },
                        [_vm._v("How to Create an Assessment")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 float-left text-text" },
                        [_vm._v('1.) Click "Add Section"')]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 float-left text-text" },
                        [
                          _vm._v(
                            "2.) Select an Existing Section to Add by clicking the check box to the left of section title OR Create an New Section"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 float-left text-text" },
                        [
                          _vm._v(
                            "3.) If creating a new section, once section is created you will see it avaliable for selection"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 float-left text-text" },
                        [
                          _vm._v(
                            '4.) Once section is selected via check box, click "Continue" to add the section to your assessment'
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 float-left text-text" },
                        [
                          _vm._v(
                            "5.) Once added, you can add more sections, Save Assessment as a Draft, or Publish the assessment"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-12 float-left text-heading",
                          staticStyle: {
                            "font-size": "16px",
                            "padding-left": "25px",
                            "font-style": "italic"
                          }
                        },
                        [
                          _vm._v(
                            "NOTE: Once published, the assessment will be made available for assigned affiliates and user types."
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-lg-12 padding-lr-5 float-left text-align-center",
                          staticStyle: {
                            "padding-right": "0",
                            "padding-top": "20px"
                          }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-white col-2 override-padding",
                              staticStyle: {
                                height: "40px",
                                "border-radius": "10px",
                                "font-weight": "bold"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.addSectionClick()
                                }
                              }
                            },
                            [_vm._v("Add Section")]
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticStyle: { clear: "both" } }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  staticClass: "loading_show"
                },
                [_c("div", { staticClass: "spinner-border text-danger" })]
              ),
              _vm._v(" "),
              _vm.assessment_section_obj.sections.length > 0
                ? _c("div", { staticClass: "section-display" }, [
                    _c(
                      "ul",
                      {
                        directives: [
                          {
                            name: "sortable",
                            rawName: "v-sortable",
                            value: {
                              onEnd: _vm.reorderSection,
                              handle: ".handle1"
                            },
                            expression:
                              "{onEnd: reorderSection, handle: '.handle1'}"
                          }
                        ],
                        staticClass:
                          "counter_section-list list-group col-lg-12  override-padding margin-bottom-10"
                      },
                      _vm._l(_vm.assessment_section_obj.sections, function(
                        section,
                        sindex
                      ) {
                        return _c(
                          "li",
                          {
                            key: section.sortid,
                            staticClass: "list-group-item input-height-25"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "section_item float-left col-12 override-padding"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 override-padding float-left"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "handle1 float-left col-lg-12 override-padding",
                                        staticStyle: { "padding-top": "2px" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-10 override-padding float-left"
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa fa-arrows padding-right-5",
                                              attrs: { "aria-hidden": "true" }
                                            }),
                                            _vm._v(" "),
                                            _vm._m(1, true),
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(section.title) +
                                                " \n                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-1 override-padding float-left"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-weight": "bold"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    SCALE: \n                    "
                                                )
                                              ]
                                            ),
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.getScale(section.scale)
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-1 override-padding float-left"
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-white col-12 padding-lr-5",
                                                staticStyle: {
                                                  height: "30px",
                                                  "border-radius": "10px",
                                                  "margin-top": "-2px",
                                                  "font-weight": "bold"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.deleteSectionConfirm(
                                                      sindex
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Remove")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticStyle: { clear: "both" }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "counter_group-list col-12 override-padding"
                              },
                              _vm._l(section.group, function(
                                section_group,
                                gindex
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: section_group.id,
                                    staticClass:
                                      "heading_item col-lg-11 float-right override-padding"
                                  },
                                  [
                                    section_group.questions.length > 0 &&
                                    section_group.name != ""
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "handle2 float-left col-lg-12 override-padding collapse-wrapper float-right",
                                            staticStyle: {
                                              "padding-top": "2px"
                                            }
                                          },
                                          [
                                            _c(
                                              "b-link",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-toggle",
                                                    rawName: "v-b-toggle",
                                                    value:
                                                      section.sortid +
                                                      "-" +
                                                      section_group.name,
                                                    expression:
                                                      "section.sortid + '-' + section_group.name"
                                                  }
                                                ]
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    "\n                      Group " +
                                                      _vm._s(
                                                        section_group.name
                                                      ) +
                                                      " \n                      "
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-angle-up",
                                                    attrs: {
                                                      "aria-hidden": "true"
                                                    }
                                                  })
                                                ])
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    section_group.questions.length > 0
                                      ? _c(
                                          "b-collapse",
                                          {
                                            staticClass: "mt-2",
                                            attrs: {
                                              id:
                                                section.sortid +
                                                "-" +
                                                section_group.name,
                                              visible: ""
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "question_items" },
                                              _vm._l(
                                                section_group.questions,
                                                function(
                                                  group_question,
                                                  qindex
                                                ) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: group_question.id,
                                                      staticClass:
                                                        "question_item col-lg-12  float-left"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "float-left col-lg-12 override-padding",
                                                          staticStyle: {
                                                            "padding-top": "2px"
                                                          }
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "counter_group-list__counter"
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "font-style":
                                                                  "italic",
                                                                "font-size":
                                                                  "13px",
                                                                "padding-left":
                                                                  "7px",
                                                                "padding-right":
                                                                  "7px"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getStatus(
                                                                    group_question.type
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                group_question.text
                                                              ) +
                                                              "\n                  "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticStyle: {
                                                clear: "both",
                                                "margin-bottom": "10px"
                                              }
                                            }),
                                            _vm._v(" "),
                                            section_group.ranges.length > 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "question_items"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "range_item col-12"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "heading-row"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-1 float-left padding-lr-5 text-align-center"
                                                              },
                                                              [_vm._v("From")]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-1 float-left padding-lr-5 text-align-center"
                                                              },
                                                              [_vm._v(" ")]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-1 float-left padding-lr-5 text-align-center"
                                                              },
                                                              [_vm._v("To")]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-9 float-left padding-lr-5"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Output Text"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      section_group.ranges,
                                                      function(
                                                        group_range,
                                                        rindex
                                                      ) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: group_range.id,
                                                            staticClass:
                                                              "range_item col-12"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-1 float-left padding-lr-5 text-align-center"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    group_range.rangefrom
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-1 float-left padding-lr-5 text-align-center"
                                                              },
                                                              [_vm._v("-")]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-1 float-left padding-lr-5 text-align-center"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    group_range.rangeto
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-9 float-left padding-lr-5"
                                                              },
                                                              [
                                                                _c("span", {
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      group_range.text
                                                                    )
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticStyle: { clear: "both", "margin-bottom": "10px" }
                    }),
                    _vm._v(" "),
                    _vm.assessment_output_range_flag == true
                      ? _c(
                          "div",
                          { staticClass: "col-12 override-padding" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "col-12 override-padding",
                                staticStyle: {
                                  "border-bottom": "2px solid #CCC",
                                  "margin-top": "15px"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "heading-row",
                                    staticStyle: {
                                      border: "0",
                                      "padding-top": "10px"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 float-left override-padding"
                                      },
                                      [
                                        _vm._v(
                                          "Assessment Details / Instructions\n                  "
                                        ),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "switch",
                                            staticStyle: {
                                              "margin-left": "10px"
                                            }
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.toogle_switch,
                                                  expression: "toogle_switch"
                                                }
                                              ],
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                checked: Array.isArray(
                                                  _vm.toogle_switch
                                                )
                                                  ? _vm._i(
                                                      _vm.toogle_switch,
                                                      null
                                                    ) > -1
                                                  : _vm.toogle_switch
                                              },
                                              on: {
                                                change: [
                                                  function($event) {
                                                    var $$a = _vm.toogle_switch,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.toogle_switch = $$a.concat(
                                                            [$$v]
                                                          ))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.toogle_switch = $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            ))
                                                      }
                                                    } else {
                                                      _vm.toogle_switch = $$c
                                                    }
                                                  },
                                                  function($event) {
                                                    return _vm.toogleChangeEvent()
                                                  }
                                                ]
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass: "slider round"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.toogle_switch == true
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 float-left override-padding assessment-details",
                                        staticStyle: {
                                          "margin-bottom": "10px",
                                          height: "150px"
                                        }
                                      },
                                      [
                                        _c("vue-editor", {
                                          attrs: {
                                            editorToolbar: _vm.customToolbar,
                                            placeholder: "Enter Text..."
                                          },
                                          model: {
                                            value: _vm.assessment_details,
                                            callback: function($$v) {
                                              _vm.assessment_details = $$v
                                            },
                                            expression: "assessment_details"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticStyle: {
                                clear: "both",
                                "margin-bottom": "0px"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col-12 override-padding",
                                staticStyle: {
                                  "border-top": "2px solid #CCC",
                                  "margin-top": "0px"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "add-statement-heading" },
                                  [
                                    _vm._v(
                                      "\n                Enter Output Ranges and Text\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticStyle: { clear: "both" } }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 add-statement-heading override-padding",
                                    staticStyle: { "padding-top": "0" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "float-left",
                                        staticStyle: { width: "13%" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Minimum = "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "rangetext" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.assessment_min_range)
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "float-left",
                                        staticStyle: { width: "13%" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Maximum = "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "rangetext" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.assessment_max_range)
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "float-left",
                                        staticStyle: { width: "13%" }
                                      },
                                      [
                                        _vm._v("\n                  Range = "),
                                        _c(
                                          "span",
                                          { staticClass: "rangetext" },
                                          [_vm._v(_vm._s(_vm.assessment_range))]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "float-left rangetext",
                                        staticStyle: {
                                          width: "13%",
                                          "font-style": "italic"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Quartile 4 = " +
                                            _vm._s(
                                              parseInt(
                                                this.assessment_range * 0.25
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "float-left rangetext",
                                        staticStyle: {
                                          width: "13%",
                                          "font-style": "italic"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Quartile 3 = " +
                                            _vm._s(
                                              parseInt(
                                                this.assessment_range * 0.5
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "float-left rangetext",
                                        staticStyle: {
                                          width: "13%",
                                          "font-style": "italic"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Quartile 2 = " +
                                            _vm._s(
                                              parseInt(
                                                this.assessment_range * 0.75
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "float-left rangetext",
                                        staticStyle: {
                                          width: "13%",
                                          "font-style": "italic"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Quartile 1 = " +
                                            _vm._s(
                                              parseInt(
                                                this.assessment_range * 1
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticStyle: { clear: "both" }
                                    })
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.assessment_output_range, function(
                              list,
                              aindex
                            ) {
                              return _c("div", { key: aindex }, [
                                _c(
                                  "div",
                                  { staticClass: "col-12 override-padding" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "heading-row",
                                        staticStyle: { border: "0" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 float-left override-padding"
                                          },
                                          [
                                            _vm._v(
                                              "Output Range " +
                                                _vm._s(parseInt(aindex + 1)) +
                                                " Title"
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 float-left override-padding",
                                        staticStyle: { "margin-bottom": "10px" }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: list.title,
                                              expression: "list.title"
                                            }
                                          ],
                                          staticClass:
                                            "col-lg-12 input-text form-control float-left padding-lr-5",
                                          staticStyle: {
                                            "line-height": "30px"
                                          },
                                          attrs: {
                                            placeholder:
                                              "Enter Output Range " +
                                              parseInt(aindex + 1) +
                                              " Title",
                                            maxlength: "250"
                                          },
                                          domProps: { value: list.title },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                list,
                                                "title",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._m(2, true),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 override-padding float-left",
                                    staticStyle: { "margin-top": "1px" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "statement-row col-12 override-padding float-left",
                                        staticStyle: { "margin-bottom": "5px" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-1 float-left override-padding"
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: list.from,
                                                  expression: "list.from"
                                                }
                                              ],
                                              staticClass:
                                                "col-lg-12 input-text form-control float-left padding-lr-5",
                                              staticStyle: {
                                                "line-height": "30px"
                                              },
                                              attrs: { maxlength: "5" },
                                              domProps: { value: list.from },
                                              on: {
                                                blur: function($event) {
                                                  return _vm.checkRangeNumbers(
                                                    aindex,
                                                    "From"
                                                  )
                                                },
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    list,
                                                    "from",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-1 float-left override-padding text-align-center",
                                            staticStyle: { "margin-top": "5px" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    -\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-1 float-left override-padding"
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: list.to,
                                                  expression: "list.to"
                                                }
                                              ],
                                              staticClass:
                                                "col-lg-12 input-text form-control float-left padding-lr-5",
                                              staticStyle: {
                                                "line-height": "30px"
                                              },
                                              attrs: { maxlength: "5" },
                                              domProps: { value: list.to },
                                              on: {
                                                blur: function($event) {
                                                  return _vm.checkRangeNumbers(
                                                    aindex,
                                                    "To"
                                                  )
                                                },
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    list,
                                                    "to",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-8 float-left padding-lr-5 assessment-details",
                                            staticStyle: {
                                              "padding-right": "0",
                                              height: "150px"
                                            }
                                          },
                                          [
                                            _c("vue-editor", {
                                              attrs: {
                                                editorToolbar:
                                                  _vm.customToolbar,
                                                placeholder: "Enter Text..."
                                              },
                                              model: {
                                                value: list.text,
                                                callback: function($$v) {
                                                  _vm.$set(list, "text", $$v)
                                                },
                                                expression: "list.text"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.assessment_output_range.length > 1
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-1 float-left delete-icon",
                                                staticStyle: {
                                                  "font-weight": "bold",
                                                  "margin-top": "5px"
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-window-close cursor-pointer",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.removeOutputRange(
                                                        aindex
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticStyle: { clear: "both" }
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticStyle: {
                                    clear: "both",
                                    "margin-bottom": "0px"
                                  }
                                })
                              ])
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-12 override-padding" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-3 override-padding float-left"
                                  },
                                  [
                                    _vm._v(
                                      "\n                 \n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-9 padding-lr-5 float-left add-on",
                                    on: {
                                      click: function($event) {
                                        return _vm.addMoreOutputText()
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-plus spacer-icon",
                                      attrs: { "aria-hidden": "true" }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "font-style": "italic" }
                                      },
                                      [_vm._v("Add Score Range (25 Max) ")]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticStyle: { clear: "both" } })
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", {
                      staticStyle: { clear: "both", "margin-bottom": "10px" }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-2 padding-lr-5 float-right text-align-right",
                        staticStyle: { "padding-right": "0" }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-red col-10 padding-lr-5",
                            staticStyle: {
                              height: "30px",
                              "border-radius": "10px",
                              "margin-top": "2px",
                              "font-weight": "bold"
                            },
                            on: { click: _vm.onSubmit }
                          },
                          [_vm._v("Save and Exit")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-2 padding-lr-5 float-right text-align-right",
                        staticStyle: { "padding-right": "0" }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-white col-8 padding-lr-5",
                            staticStyle: {
                              height: "30px",
                              "border-radius": "10px",
                              "margin-top": "2px",
                              "font-weight": "bold"
                            },
                            on: { click: _vm.onPreview }
                          },
                          [_vm._v("Preview")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-2 padding-lr-5 float-right text-align-right"
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-white col-8 override-padding",
                            staticStyle: {
                              "margin-top": "2px",
                              height: "30px",
                              "border-radius": "10px",
                              "font-weight": "bold"
                            },
                            on: {
                              click: function($event) {
                                return _vm.addSectionClick()
                              }
                            }
                          },
                          [_vm._v("Add Section")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticStyle: { clear: "both", "margin-bottom": "25px" }
                    })
                  ])
                : _vm._e()
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "EditAssessmentModal",
        {
          attrs: { isModalVisible: _vm.isEditModalVisible },
          on: {
            close: function($event) {
              _vm.isEditModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("h3", [_vm._v("Edit Assessment")])]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "body" }, slot: "body" }, [
            _c("div", { staticClass: "col-12 override-padding" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.assessment_title,
                    expression: "assessment_title"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "col-lg-12 input-text form-control",
                staticStyle: { "line-height": "30px" },
                attrs: {
                  name: "assessment_title",
                  placeholder: "Enter Assessment Title...",
                  maxlength: "255"
                },
                domProps: { value: _vm.assessment_title },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.assessment_title = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _vm.verrors.firstByRule("assessment_title", "required")
                ? _c(
                    "div",
                    { staticClass: "margin-bottom-5 validate-warning-msg" },
                    [_vm._v("Assessment Title is required")]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "margin-bottom-10",
              staticStyle: { clear: "both" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 override-padding" }, [
              _c(
                "div",
                {
                  staticClass: "search-padd",
                  attrs: { id: "mentee-group-wrapper" }
                },
                [
                  _c("multiselect", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      options: _vm.affiliate_options,
                      "track-by": "name",
                      label: "name",
                      placeholder: "Select Affiliates...",
                      multiple: true,
                      "close-on-select": false,
                      "show-labels": false,
                      name: "affiliate",
                      id: "affiliate"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "selection",
                        fn: function(ref) {
                          var values = ref.values
                          var search = ref.search
                          var isOpen = ref.isOpen
                          return [
                            values.length && !isOpen
                              ? _c(
                                  "span",
                                  { staticClass: "multiselect__single" },
                                  [_vm._v(_vm._s(values.length) + " selected")]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.affiliate_selected,
                      callback: function($$v) {
                        _vm.affiliate_selected = $$v
                      },
                      expression: "affiliate_selected"
                    }
                  }),
                  _vm._v(" "),
                  _vm.verrors.firstByRule("affiliate", "required")
                    ? _c(
                        "div",
                        { staticClass: "margin-bottom-5 validate-warning-msg" },
                        [_vm._v("Affilates is required")]
                      )
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "margin-bottom-10",
              staticStyle: { clear: "both" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 override-padding" }, [
              _c(
                "div",
                {
                  staticClass: "search-padd",
                  attrs: { id: "mentee-group-wrapper" }
                },
                [
                  _c("multiselect", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      options: _vm.roles_options,
                      "track-by": "name",
                      label: "name",
                      placeholder: "Select Users...",
                      multiple: true,
                      "close-on-select": false,
                      "show-labels": false,
                      name: "roles",
                      id: "roles"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "selection",
                        fn: function(ref) {
                          var values = ref.values
                          var search = ref.search
                          var isOpen = ref.isOpen
                          return [
                            values.length && !isOpen
                              ? _c(
                                  "span",
                                  { staticClass: "multiselect__single" },
                                  [_vm._v(_vm._s(values.length) + " selected")]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.roles_selected,
                      callback: function($$v) {
                        _vm.roles_selected = $$v
                      },
                      expression: "roles_selected"
                    }
                  }),
                  _vm._v(" "),
                  _vm.verrors.firstByRule("roles", "required")
                    ? _c(
                        "div",
                        { staticClass: "margin-bottom-5 validate-warning-msg" },
                        [_vm._v("Users is required")]
                      )
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "margin-bottom-10",
              staticStyle: { clear: "both" }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "margin-bottom-10",
              staticStyle: { clear: "both" }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 override-padding text-align-right" },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-red col-lg-3",
                    staticStyle: {
                      "line-height": "30px",
                      "border-radius": "10px"
                    },
                    on: {
                      click: function($event) {
                        return _vm.editAssessment()
                      }
                    }
                  },
                  [_c("b", [_vm._v("Update")])]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "col-3 override-padding",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "DeleteModal",
        {
          attrs: {
            isModalVisible: _vm.isModalVisible,
            id: _vm.id,
            parent_id: _vm.parent_id
          },
          on: {
            close: function($event) {
              _vm.isModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_vm._v(_vm._s(_vm.deleteMessage))]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "body" }, slot: "body" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-3 override-padding",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "button",
                {
                  staticClass: "left col-12 btn btn-red",
                  on: {
                    click: function($event) {
                      _vm.isModalVisible = false
                      _vm.deleteAction()
                    }
                  }
                },
                [_vm._v("Confirm")]
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "heading-row col-12 override-padding",
        staticStyle: { border: "0", "padding-top": "10px" }
      },
      [
        _c("div", { staticClass: "col-9 float-left override-padding" }, [
          _vm._v("Assessment Introduction / Landing Page\n            ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-3 float-left override-padding" }, [
          _vm._v("Intro Auto-Fill Assets\n            ")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticStyle: { "font-weight": "bold" } }, [
      _vm._v("\n                    Section \n                    "),
      _c("span", { staticClass: "counter_section-list__counter" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 override-padding" }, [
      _c("div", { staticClass: "heading-row", staticStyle: { border: "0" } }, [
        _c("div", { staticClass: "col-1 float-left override-padding" }, [
          _vm._v("From")
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-1 float-left override-padding text-align-center"
          },
          [_vm._v(">/<")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-1 float-left override-padding" }, [
          _vm._v("To")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-9 float-left padding-lr-5" }, [
          _vm._v("Output Text")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bde7ddcc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bde7ddcc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/assessment_add_section.vue
// module id = null
// module chunks = 